import { Box, Heading, HStack, Stack, Tag, Text, VStack } from '@chakra-ui/react';
import { FileCheck02, LinkExternal01 } from '@untitled-ui/icons-react';
import { LooseObject } from 'api/types';
import Link from 'components/Link';
import { useUserContext } from 'context/UserContextProvider';
import { getI18nKeyForStatus } from 'helpers/statusTranslations';
import { useTranslation } from 'react-i18next';

import { StatusTag } from './StatusTag';

export const VerificationStatusCard = (props: {
  completedAt?: string;
  currentStatus?: number;
  currentStatusReason?: number;
  resourceKey: string;
  workshopVerificationQueryData: LooseObject;
}) => {
  const { t } = useTranslation();
  const { completedAt, currentStatus, currentStatusReason, resourceKey, workshopVerificationQueryData: workshopVerificationQuery } = props;
  const { statusCodes } = useUserContext();

  const isSystemPartnerFull = workshopVerificationQuery?.systempartner?.integration === 'full';
  const isDataChangeVerification = workshopVerificationQuery?.workshop_update_request_id;

  return (
    <HStack justifyContent="space-between" width={'100%'}>
      <VStack alignItems={'flex-start'}>
        <HStack alignItems="flex-start" gap="4">
          <Box>
            <FileCheck02 />
          </Box>
          <Stack>
            <HStack>
              <Heading as="h2" size="xxs">
                {`${t('workshop_verification_request:verified_by')} ${
                  workshopVerificationQuery.workshop?.firstname
                } ${workshopVerificationQuery.workshop?.lastname} ( ${workshopVerificationQuery?.user_readable_id} )`}
              </Heading>
              {isSystemPartnerFull && (
                <Tag colorScheme="purple" variant="outline" textTransform="uppercase">
                  {workshopVerificationQuery.systempartner?.name}
                </Tag>
              )}
              {isDataChangeVerification && (
                <Tag colorScheme="blue" variant="outline" textTransform="uppercase">
                  {t('workshop_verification_request:data_change_tag.label')}
                </Tag>
              )}
            </HStack>
            <Link display="flex" gap="2" to={`/app/op/workshops/${workshopVerificationQuery?.workshop_id}`}>
              {t('service_history_request:workshops.title')} <LinkExternal01 />
            </Link>
          </Stack>
        </HStack>
      </VStack>

      <VStack alignItems="flex-end">
        <StatusTag
          completedAt={completedAt}
          resourceKey={resourceKey}
          currentStatus={currentStatus ?? 0}
          currentStatusReason={currentStatusReason}
          textTransform={''}
          isVerification={true}
        />

        <Text fontSize={'sm'} fontWeight={'bold'} as={'span'} textColor={'grey'}>
          {t(getI18nKeyForStatus(statusCodes, resourceKey, currentStatus ?? 0, 'description'))}
        </Text>
      </VStack>
    </HStack>
  );
};
